module.exports = __webpack_public_path__ + "static/img/0000智慧食堂打印程序.36bf7c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/0000智慧食堂打印程序.jpg
// module id = uo5A
// module chunks = 0